import React, { Fragment } from 'react'
import Fade from 'react-reveal/Fade';
import Policiespdfs from './Policiespdfs';


function PoliciesBanner() {
    return (
        <Fragment>
            <div className='container governancemain motor' >
                <div className='row arrticleAndBlogs'>

                <div className='col-sm-12 heads govbanner ourpolicy'>
                        <Fade up delay={500}><h2 className="oswald">Policies</h2></Fade>
                    </div>

                    <div className='col-sm-12 heads text mymaxheight'>
                        <Policiespdfs/>
                    </div>

                
                </div>
            </div>
        </Fragment>
    )
}

export default PoliciesBanner